import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { http, errMsg } from "@/lib/api";

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <div className="min-h-screen grid place-items-center bg-[linear-gradient(140deg,#F7FAFC,#E2F2FB)] p-4">
    <div className="w-full max-w-sm rounded-3xl bg-white border border-nanina-line p-6 sm:p-8 shadow-[0_20px_60px_rgba(35,75,67,0.1)]" data-testid={testId}>
      <img src="/logo-nanina.png" alt="Logo Nanina Care" className="h-14 w-14" />
      <h1 className="mt-3 text-2xl font-extrabold tracking-tight text-nanina-green">{title}</h1>
      <p className="text-xs text-nanina-muted">{subtitle}</p>
      {children}
      <Link to="/admin/login" className="mt-4 block text-center text-xs text-nanina-muted hover:text-nanina-green" data-testid="auth-back-login-link">Kembali ke login</Link>
    </div>
  </div>
);

export const authInput = "mt-1.5 w-full rounded-xl border border-[#DCEAE6] px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-nanina-sky/50";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Lupa Kata Sandi?" subtitle="Masukkan email admin yang terdaftar. Kami akan mengirim tautan untuk membuat kata sandi baru." testId="forgot-password-page">
      {msg ? (
        <p className="mt-5 rounded-xl bg-nanina-freshsoft p-3 text-xs text-nanina-green" role="status" data-testid="forgot-password-message">{msg} Periksa juga folder spam. Tautan berlaku 30 menit.</p>
      ) : (
        <form onSubmit={submit} data-testid="forgot-password-form">
          <label className="mt-5 block text-xs font-semibold text-nanina-green">Email
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" className={authInput} data-testid="forgot-password-email-input" />
          </label>
          {error && <p className="mt-3 text-xs text-red-600" role="alert" data-testid="forgot-password-error">{error}</p>}
          <button disabled={busy} className="mt-5 w-full inline-flex justify-center items-center gap-2 rounded-full bg-nanina-green text-white text-sm font-semibold py-3 disabled:opacity-60" data-testid="forgot-password-submit-button">
            <Mail className="h-4 w-4" /> {busy ? "Memproses..." : "Kirim tautan reset"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
